import AreaContainer from "../AreaContainer";
import styles from './accomodation.module.css';
import globalStyles from '../result.module.css';

interface Props {
  accommodation: any;
  accommodationDescription: string; 
  size: string | number;
}

interface AreaDmensions {
  title: string,
  size_ft: string,
  size_m: string
}

const Accommodation = ({ accommodation, accommodationDescription, size }: Props) => {
  let areas: AreaDmensions[] = [];
  let dimensions: AreaDmensions[] = [];

  if (!accommodation) return null;

  for (let item of accommodation) {
    if (item.type === "area") areas.push(item);
    else dimensions.push(item);
  }

  if(!accommodationDescription && !size && areas.length == 0 && dimensions.length == 0) return null;

  return (
    <AreaContainer area="accomodation"  style={null} extraClass={undefined}>
      <div className={styles.InfomationWrapper}>
        <h2 className={globalStyles.subTitleText}>Accommodation</h2>
        {size && <p className={`${globalStyles.largeText} ${globalStyles.lightColorText} ${globalStyles.boldText}`} style={{marginBottom:'1rem'}}>{size} Sq.Ft</p>}
        {accommodationDescription && <p className={`${globalStyles.mediumText} ${globalStyles.lightColorText}`} style={{marginBottom:'1rem'}} dangerouslySetInnerHTML={{__html:accommodationDescription}}></p>}
        {dimensions.length > 0 && <div className={styles.gridContainer}>
          <div className={styles.gridRow}>
            <div className={styles.gridCell}><div className={globalStyles.mediumText}>Dimensions</div></div>
            <div className={`${styles.gridCell} ${globalStyles.mediumText}`}>
              Feet
            </div>
            <div className={`${styles.gridCell} ${globalStyles.mediumText}`}>
              Metres
            </div>
          </div>
          {dimensions.map((row, i) => {
            return (
              <div className={styles.gridRow} key={i}>
                <div className={`${styles.gridCell} ${globalStyles.mediumText}`}>
                  {row.title}
                </div>
                <div className={`${styles.gridCell} ${globalStyles.lightColorText}`}>
                  {parseFloat(row.size_ft).toLocaleString()}
                </div>
                <div className={`${styles.gridCell} ${globalStyles.lightColorText}`}>
                  {parseFloat(row.size_m).toLocaleString()}
                </div>
              </div>
            );
          })}
        </div>}
        {areas.length > 0 && <div className={styles.gridContainer}>
          <div className={styles.gridRow}>
            <div className={`${styles.gridCell} ${globalStyles.mediumText}`}>Areas</div>
            <div className={`${styles.gridCell} ${globalStyles.mediumText}`}>
             Sq.Ft
            </div>
            <div className={styles.gridCell}>
              Sq.M
            </div>
          </div>
          {areas.map((row, i) => {
            return (
              <div className={styles.gridRow} key={i}>
                <div className={`${styles.gridCell} ${globalStyles.mediumText}`}>
                  {row.title}
                </div>
                <div className={`${styles.gridCell} ${globalStyles.lightColorText} ${globalStyles.mediumText}`}>
                  {parseFloat(row.size_ft).toLocaleString()}
                </div>
                <div className={`${styles.gridCell} ${globalStyles.lightColorText} ${globalStyles.mediumText}`}>
                  {parseFloat(row.size_m).toLocaleString()}
                </div>
              </div>
            );
          })}
        </div>}
      </div>
    </AreaContainer>
  );
};

export default Accommodation;
